import Button from 'components/Button';
import FormGroup from 'components/FormGroup';
import {
  GooglePlaceAutoComplete,
  TypeGooglePlaceDetail,
} from 'components/GooglePlaceAutoComplete';
import MapPreview from 'components/MapPreview';
import Modal from 'components/Modal';
import TextField from 'components/TextField';
import {Controller, useForm} from 'react-hook-form';
import styles from './AddAddressModal.module.scss';
import {createAddress} from 'types';
import {useState} from 'react';
import {AxiosResponse} from 'axios';
import toast from 'react-hot-toast';

interface AddAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (data: createAddress) => void;
  createNewAddress: (
    newAddress: createAddress
  ) => Promise<AxiosResponse<any, any>>;
  customer_id: number;
}

function AddAddressModal({
  isOpen,
  onClose,
  onSuccess,
  createNewAddress,
  customer_id,
}: AddAddressModalProps) {
  const {control, handleSubmit, setValue, reset} = useForm<createAddress>();
  const [location, setLocation] = useState({
    latitude: 40.7596958,
    longitude: -73.9650045,
  });
  const onSelectPlace = (placeDetail: TypeGooglePlaceDetail) => {
    setValue('latitude', placeDetail.lat);
    setValue('longitude', placeDetail.lon);
    setTimeout(() => {
      setLocation({latitude: placeDetail.lat, longitude: placeDetail.lon});
    }, 300);
    setValue('zipcode', placeDetail.zipcode);
    setValue('address_line_1', placeDetail.addressLine1);
    setValue('city', placeDetail.city);
    setValue('state', placeDetail.state);
  };
  const handleCreation = async (datas: createAddress) => {
    const res = await createNewAddress({
      ...datas,
      customer_id,
    });

    if (res?.status === 200) {
      onClose();
      onSuccess(res.data);
      reset();
      setLocation({
        latitude: 40.7596958,
        longitude: -73.9650045,
      });
    } else {
      toast.error('Something wrong with creation. Try again later !');
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.list_wrapper}>
      <div className={styles.modalWrapper}>
        <FormGroup>
          <Controller
            name="city"
            control={control}
            rules={{required: 'Please, Select the address'}}
            render={({field, fieldState}) => (
              <GooglePlaceAutoComplete
                label="Your address"
                placeholder="Address"
                onPlaceSelected={onSelectPlace}
                error={fieldState.error?.message}
                options={{
                  types: ['address'],
                }}
              />
            )}
          />
          <Controller
            name="unit_address"
            control={control}
            render={({field, fieldState}) => (
              <TextField
                label="Unit number"
                wrapperClass={styles.googleInput}
                placeholder="Enter unit number"
                hasError={false}
                onChange={field.onChange}
                error={fieldState.error?.message}
              />
            )}
          />
        </FormGroup>

        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 20,
          }}
        >
          {!!location.latitude && (
            <MapPreview
              zoom={15}
              onDrag={(location) => {
                setValue('latitude', location.lat);
                setValue('longitude', location.lon);
              }}
              center={[location.latitude, location.longitude]}
            />
          )}
        </div>

        <div className={styles.actionWrapper}>
          <Button type="submit" onClick={handleSubmit(handleCreation)}>
            Add
          </Button>
        </div>
      </div>
    </Modal>
  );
}
export default AddAddressModal;
